import { CatalogCta, CatalogHero, CatalogLayout, ProductGrid } from "../components/catalog";
import { THOR_PRODUCTS } from "../data/products";

export function ThorSeriesPage() {
  return (
    <CatalogLayout
      title="Ego Thor Series"
      description="Compare Thor-Duo, Thor-Quad and Thor-Hex visual-inertial capture systems."
    >
      <CatalogHero
        label="Capture / Ego Thor"
        title="Ego Thor Series"
        intro="Choose two, four or six cameras for your task. Each stereo module pairs vision with an IMU, with a synchronization board connecting multi-module systems."
      />
      <section className="catalog-wrap catalog-section catalog-first">
        <ProductGrid products={THOR_PRODUCTS} />
        <div className="catalog-table-scroll" tabIndex={0} aria-label="Thor configuration comparison">
          <table>
            <caption>Standard configurations</caption>
            <thead>
              <tr>
                <th scope="col">Specification</th>
                {THOR_PRODUCTS.map((e) => (
                  <th scope="col" key={e.slug}>
                    {e.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {THOR_PRODUCTS[0].groups[0].rows.map((e, t) => (
                <tr key={e[0]}>
                  <th scope="row">{e[0]}</th>
                  {THOR_PRODUCTS.map((n) => (
                    <td key={n.slug}>{n.groups[0].rows[t][1]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="catalog-note">{THOR_PRODUCTS[0].note}</p>
      </section>
      <section className="catalog-band">
        <div className="catalog-wrap catalog-section">
          <h2>A shared visual-inertial foundation.</h2>
          <div className="catalog-features">
            {THOR_PRODUCTS[0].features.map(([e, t]) => (
              <article key={e}>
                <h3>{e}</h3>
                <p>{t}</p>
              </article>
            ))}
          </div>
          <p className="catalog-note">
            Expanded 8 / 10 / 12-camera arrays, alternative optics and custom mounting are project options.
            Confirm timing, calibration, power and delivery for the selected configuration.
          </p>
        </div>
      </section>
      <CatalogCta />
    </CatalogLayout>
  );
}
